import { render, staticRenderFns } from "./ManutenzioneRegole.vue?vue&type=template&id=27d19292&scoped=true&"
import script from "./ManutenzioneRegole.vue?vue&type=script&lang=js&"
export * from "./ManutenzioneRegole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d19292",
  null
  
)

export default component.exports